import axios from "axios";
import { ROUTES } from "./routes";

const BASE_URL =
  process.env.REACT_APP_BASE_URL || "https://staging.carnot-traclytics.com";

export const getUser = async ({ requestUser }) => {
    try {
      const res = await axios.post(
        `${BASE_URL}${ROUTES.VERIFY_OTP}`,
        {
          username: requestUser.username,
          email: requestUser.email,
          portal_name: "Swaraj SmartProtect",
          otp: requestUser.otp,
        },
        { withCredentials: true }
      );
      return res.data;
    } catch (err) {
      throw err;
    }
  };


export const getPreLogin = async ({ requestUser }) => {
    try {
      const res = await axios.post(
        `${BASE_URL}${ROUTES.LOGIN}`,
        { username:requestUser.username, email: requestUser.email, password: requestUser.password, portal_name: "Swaraj SmartProtect" }
      );
      return res.data;
    } catch (err) {
      throw err;
    }
  };

export const getSessionStatus = async () => {
    try {
      const res = await axios.get(
        `${BASE_URL}${ROUTES.SESSION_CHECK}`,
        { withCredentials: true }
      );
      return res.data;
    } catch (err) {
      throw err;
    }
  };

export const logoutUser = async () => {
    try {
      const res = await axios.post(
        `${BASE_URL}${ROUTES.LOGOUT}`,
        {},
        { withCredentials: true }
      );
      return res.data;
    } catch (err) {
      throw err;
    }
  };